export function sanitizePagePathInput(value = '') {
    return String(value)
        .toLowerCase()
        .replace(/\\/g, '/')
        .trimStart()
        .replace(/[^a-z0-9/ -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/\/+/g, '/')
        .replace(/\/-+/g, '/')
        .replace(/-+\//g, '/')
        .replace(/^[-/]+/, '');
}

export function finalizePagePath(value = '') {
    return sanitizePagePathInput(value).replace(/[-/]+$/g, '');
}
